var React = require('react');

function MailIconBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#414042","d":"M2 20V2.9l12.4 8.9c.2.1.4.2.6.2.2 0 .4-.1.6-.2L28 2.9V20H2zM25.9 2L15 9.8 4.1 2h21.8zM30 .9V.7c0-.1 0-.1-.1-.2V.4l-.1-.1c0-.1-.1-.1-.1-.1-.1 0-.1-.1-.2-.1s-.1 0-.2-.1H.7C.6 0 .6 0 .5.1.4.1.4.2.3.2S.2.3.2.3L.1.4v.1c0 .1-.1.1-.1.2V21c0 .6.4 1 1 1h28c.6 0 1-.4 1-1V.9z"}));
}

MailIconBlack.defaultProps = {"viewBox":"0 0 30 22","id":"icon-mail"};

module.exports = MailIconBlack;

MailIconBlack.default = MailIconBlack;
